import {
  SHOW_LOADER,
  SHOW_TOAST,
  SHOW_CHAT,
  UPDATE_LOGGED_IN_ROUTE,
  GET_ASSIGNMENT_TYPE_LIST,
  GET_CANCEL_REASON_LIST,
  GET_SERVICES_LIST,
  GET_SUBJECTS_LIST,
  GET_ACADEMIC_LEVEL_LIST,
  GET_UNIVERSITIES_LIST,
  GET_REFERENCING_STYLE_LIST,
  GET_SOFTWARE_REQUIRED_LIST,
  GET_HIGHEST_DEGREE_LIST,
  GET_SPECIALIZATION_LIST,
  GET_COUNTRIES_LIST,
  GET_OUTSOURCED_TASKS_LIST,
  GET_WORD_COUNT_LIST,
  REMOVE_COMMON_STATE,
  GET_CONTENT_TEAM_SPECIALIZATION_LIST,
  GET_CONTENT_WRITER_SPECIALIZATION_LIST,
  GET_CONTENT_WRITING_INDUSTRIES_LIST,
  GET_CONTENT_WRITER_INDUSTRIES_LIST,
  GET_CONTENT_WRITING_TEAM_STRENGTH_LIST
} from "./commonActions";

// We need to have an initial state values
const initialState = {
  loaderState: { show: false, msg: "" },
  toastState: { show: false, msg: "" },
  chatState: false,
  openLoggedInRoute: undefined,
  assignmentTypeData: { error: true, data: [], message: "no data" },
  cancellationReason: { error: true, data: [], message: "no data" },
  serviceData: { error: true, data: [], message: "no data" },
  subjectData: { error: true, data: [], message: "no data" },
  academicLevelData: { error: true, data: [], message: "no data" },
  universityData: { error: true, data: [], message: "no data" },
  referencingStyleData: { error: true, data: [], message: "no data" },
  softwareRequirementData: { error: true, data: [], message: "no data" },
  highestDegreeData: { error: true, data: [], message: "no data" },
  specializationData: { error: true, data: [], message: "no data" },
  countryData: { error: true, data: [], message: "no data" },
  tasksOutsourcedData: { error: true, data: [], message: "no data" },
  wordCountData: { error: true, data: [], message: "no data" },
};

// Then we need to have the reducer
const commonReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHOW_LOADER:
      return {
        ...state,
        loaderState: payload,
      };

    case SHOW_TOAST:
      return {
        ...state,
        toastState: payload,
      };

    case SHOW_CHAT:
      return {
        ...state,
        chatState: payload,
      };

    case GET_ASSIGNMENT_TYPE_LIST:
      return {
        ...state,
        assignmentTypeData: payload,
      };

    case GET_CANCEL_REASON_LIST:
      return {
        ...state,
        cancellationReason: payload,
      };

    case GET_SERVICES_LIST:
      return {
        ...state,
        serviceData: payload,
      };

    case GET_SUBJECTS_LIST:
      return {
        ...state,
        subjectData: payload,
      };

    case GET_ACADEMIC_LEVEL_LIST:
      return {
        ...state,
        academicLevelData: payload,
      };

    case GET_UNIVERSITIES_LIST:
      return {
        ...state,
        universityData: payload,
      };

    case GET_REFERENCING_STYLE_LIST:
      return {
        ...state,
        referencingStyleData: payload,
      };

    case GET_SOFTWARE_REQUIRED_LIST:
      return {
        ...state,
        softwareRequirementData: payload,
      };

    case GET_HIGHEST_DEGREE_LIST:
      return {
        ...state,
        highestDegreeData: payload,
      };

    case GET_SPECIALIZATION_LIST:
      return {
        ...state,
        specializationData: payload,
      };

    case GET_CONTENT_TEAM_SPECIALIZATION_LIST:
      return {
        ...state,
        contentTeamSpecializationData: payload,
      };

    case GET_CONTENT_WRITER_SPECIALIZATION_LIST:
      return {
        ...state,
        contentWriterSpecializationData: payload,
      };

    case GET_CONTENT_WRITING_INDUSTRIES_LIST:
      return {
        ...state,
        contentWritingIndustriesData: payload,
      };

    case GET_CONTENT_WRITER_INDUSTRIES_LIST:
      return {
        ...state,
        contentWriterIndustriesData: payload,
      };
    case GET_CONTENT_WRITING_TEAM_STRENGTH_LIST:
      return {
        ...state,
        contentWritingTeamStrengthData: payload,
      };

    case GET_COUNTRIES_LIST:
      return {
        ...state,
        countryData: payload,
      };

    case GET_OUTSOURCED_TASKS_LIST:
      return {
        ...state,
        tasksOutsourcedData: payload,
      };

    case GET_WORD_COUNT_LIST:
      return {
        ...state,
        wordCountData: payload,
      };

    case REMOVE_COMMON_STATE:
      return {
        ...initialState
      };

    case UPDATE_LOGGED_IN_ROUTE:
      return {
        ...state,
        openLoggedInRoute: payload,
      };

    default:
      return state;
  }
};

export default commonReducer;
